// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg-color: #1a1a1a;
    --text-color: #f2f2f2;
    --quote-color: #cccccc;
    --metadata-color: #999999;
    --tree-color: #555555;
}

.light-mode {
    --bg-color: #d4d4d4;
    --text-color: #1a1a1a;
    --quote-color: #333333;
    --metadata-color: #434343;
    --tree-color: #494949;
}

body {
    background-color: var(--bg-color);
    color: var(--text-color);
    font-family: "Helvetica Neue", Arial, sans-serif;
    font-weight: 300;
    font-size: 18px;
    text-align: center;
    margin: 0;
    padding: 0;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: none;
}

button {
    font-family: inherit;
}

body.no-transition,
body.no-transition *,
body.no-transition *:before,
body.no-transition *:after {
    transition: none !important;
}

body.light-mode,
body.dark-mode {
    transition: background-color 0.3s ease, color 0.3s ease;
}

.dev-indicator {
    position: fixed;
    right: 16px;
    bottom: 16px;
    font-size: 12px;
    letter-spacing: 0.08em;
    padding: 6px 10px;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.35);
    z-index: 1000;
    pointer-events: none;
}

.quote-container {
    width: 90%;
    max-width: 800px;
    border-radius: 10px;
    padding: 40px;
}

.quote-text {
    font-family: "Noto Sans Tamil", Arial, sans-serif;
    font-size: 32px;
    line-height: 1.4;
    margin-bottom: 20px;
    color: var(--quote-color);
    text-align: left;
    /* Debug styles to ensure visibility */
    min-height: 30px;
}
.quote-text > div {
    white-space: nowrap;
    overflow-wrap: normal;
    word-break: keep-all;
}

.quote-explanation, .quote-mv {
    font-size: 20px;
    line-height: 1.5;
    margin-bottom: 20px;
    color: var(--quote-color);
    text-align: left;
}

.quote-number {
    font-size: 28px;
    color: var(--metadata-color);
    text-align: left;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.refresh-button {
    border: 1px solid var(--tree-color);
    background: transparent;
    color: var(--metadata-color);
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
}

.refresh-button:hover {
    color: var(--text-color);
    border-color: var(--text-color);
}

.quote-metadata {
    font-size: 16px;
    color: var(--metadata-color);
    text-align: left;
    margin-bottom: 15px;
    /* Debug styles to ensure visibility */
    min-height: 20px;
}

.metadata-placeholder {
    font-style: italic;
    opacity: 0.7;
}

.metadata-tree {
    position: relative;
    padding-left: 15px;
    display: block;
    color: var(--metadata-color);
    text-decoration: none;
    transition: color 0.3s ease;
}

.metadata-tree:visited {
    color: var(--metadata-color);
}

.metadata-tree:hover,
.metadata-tree:active {
    color: var(--quote-color);
}

.metadata-tree::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: var(--tree-color);
    transition: background-color 0.3s ease;
}

.metadata-tree .section {
    margin-bottom: 5px;
}

.metadata-tree .chapter {
    position: relative;
    padding-left: 10px;
}

.metadata-tree .chapter::before {
    content: '';
    position: absolute;
    left: -15px;
    top: 50%;
    width: 16px;
    height: 1px;
    background-color: var(--tree-color);
    transition: background-color 0.3s ease;
}

.metadata-tree:hover::before,
.metadata-tree:hover .chapter::before {
    background-color: var(--quote-color);
}

.mode-toggle {
    position: fixed;
    top: 20px;
    right: 20px;
}

.mode-switch {
    display: none;
}

.mode-switch-label {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: var(--bg-color);
    border-radius: 50%;
    transition: background-color 0.3s ease;
}

.sun-moon-icon {
    width: 24px;
    height: 24px;
    transition: transform 0.3s ease;
}

.sun, .sun-ray {
    opacity: 0;
    transition: opacity 0.3s ease;
}

.moon {
    opacity: 1;
    transition: opacity 0.3s ease;
}

.mode-switch:checked + .mode-switch-label .sun,
.mode-switch:checked + .mode-switch-label .sun-ray {
    opacity: 1;
}

.mode-switch:checked + .mode-switch-label .moon {
    opacity: 0;
}

.mode-switch:checked + .mode-switch-label .sun-moon-icon {
    transform: rotate(180deg);
}

body.no-transition .mode-switch-label,
body.no-transition .sun-moon-icon,
body.no-transition .sun,
body.no-transition .sun-ray,
body.no-transition .moon {
    transition: none !important;
}

a { color: inherit; 
  text-decoration: none;
} 

.star-button {
    border: 1px solid var(--tree-color);
    background: transparent;
    color: var(--metadata-color);
    border-radius: 999px;
    width: 28px;
    height: 28px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.star-button:hover {
    color: var(--text-color);
    border-color: var(--text-color);
}

.star-button.is-starred {
    color: var(--text-color);
    border-color: var(--text-color);
}

.star-icon {
    fill: none;
    stroke: currentColor;
    stroke-width: 1.6;
    stroke-linejoin: round;
}

.star-button.is-starred .star-icon {
    fill: currentColor;
    stroke: currentColor;
}

.favourites-section {
    margin-top: 20px;
    text-align: left;
    position: relative;
}

.favourites-toggle {
    border: 1px solid var(--tree-color);
    background: transparent;
    color: var(--metadata-color);
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 14px;
    cursor: pointer;
}

.favourites-toggle:disabled {
    opacity: 0.5;
    cursor: default;
}

.favourites-toggle:hover:not(:disabled) {
    color: var(--text-color);
    border-color: var(--text-color);
}

.favourites-list {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 12px);
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 320px;
    overflow-y: auto;
    padding-right: 6px;
    padding: 10px;
    border: 1px solid var(--tree-color);
    border-radius: 8px;
    background: var(--bg-color);
    z-index: 10;
    scrollbar-width: thin;
    scrollbar-color: var(--tree-color) transparent;
}

.favourites-list::-webkit-scrollbar {
    width: 8px;
}

.favourites-list::-webkit-scrollbar-track {
    background: transparent;
}

.favourites-list::-webkit-scrollbar-thumb {
    background-color: var(--tree-color);
    border-radius: 999px;
    border: 2px solid transparent;
    background-clip: padding-box;
}

.favourites-list::-webkit-scrollbar-thumb:hover {
    background-color: var(--metadata-color);
}

.favourites-item {
    border: 1px solid var(--tree-color);
    background: transparent;
    color: var(--quote-color);
    border-radius: 6px;
    display: flex;
    align-items: stretch;
    gap: 8px;
}

.favourites-item:hover {
    border-color: var(--quote-color);
    color: var(--text-color);
}

.favourites-number {
    color: var(--metadata-color);
    font-size: 12px;
    min-width: 26px;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.favourites-line {
    font-size: 14px;
    display: block;
    white-space: nowrap;
    overflow-wrap: normal;
    word-break: keep-all;
}

.favourites-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.favourites-select {
    border: none;
    background: transparent;
    color: inherit;
    text-align: left;
    cursor: pointer;
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 8px 10px;
    flex: 1;
}

.favourites-remove {
    border: none;
    background: transparent;
    color: var(--metadata-color);
    cursor: pointer;
    padding: 8px 10px;
    font-size: 12px;
}

.favourites-remove:hover {
    color: var(--text-color);
}

.favourites-empty {
    color: var(--metadata-color);
    font-size: 14px;
}



@media (max-width: 600px) {
    .quote-container {
        width: 95%;
        padding: 30px;
    }

    .quote-text {
        font-size: 20px;
    }

    .quote-explanation, .quote-mv {
        font-size: 16px;
    }

    .quote-number {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .quote-metadata {
        font-size: 12px;
        margin-bottom: 10px;
    }
}

.mode-switch-label,
.mode-switch-label::after {
    transition: all 0.3s ease;
}

body.no-transition .mode-switch-label,
body.no-transition .mode-switch-label::after {
    transition: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,gDAAgD;IAChD,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;;;IAII,2BAA2B;AAC/B;;AAEA;;IAEI,uDAAuD;AAC3D;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,WAAW;IACX,2CAA2C;IAC3C,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iDAAiD;IACjD,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,4BAA4B;IAC5B,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU;IACV,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,6BAA6B;AACjC;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,2BAA2B;AAC/B;;AAEA,IAAI,cAAc;EAChB,qBAAqB;AACvB;;AAEA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,4BAA4B;IAC5B,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,oBAAoB;IACpB,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;;;AAIA;IACI;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,2BAA2B;AAC/B","sourcesContent":[":root {\n    --bg-color: #1a1a1a;\n    --text-color: #f2f2f2;\n    --quote-color: #cccccc;\n    --metadata-color: #999999;\n    --tree-color: #555555;\n}\n\n.light-mode {\n    --bg-color: #d4d4d4;\n    --text-color: #1a1a1a;\n    --quote-color: #333333;\n    --metadata-color: #434343;\n    --tree-color: #494949;\n}\n\nbody {\n    background-color: var(--bg-color);\n    color: var(--text-color);\n    font-family: \"Helvetica Neue\", Arial, sans-serif;\n    font-weight: 300;\n    font-size: 18px;\n    text-align: center;\n    margin: 0;\n    padding: 0;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: none;\n}\n\nbutton {\n    font-family: inherit;\n}\n\nbody.no-transition,\nbody.no-transition *,\nbody.no-transition *:before,\nbody.no-transition *:after {\n    transition: none !important;\n}\n\nbody.light-mode,\nbody.dark-mode {\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.dev-indicator {\n    position: fixed;\n    right: 16px;\n    bottom: 16px;\n    font-size: 12px;\n    letter-spacing: 0.08em;\n    padding: 6px 10px;\n    border-radius: 999px;\n    background: rgba(0, 0, 0, 0.4);\n    color: #fff;\n    border: 1px solid rgba(255, 255, 255, 0.35);\n    z-index: 1000;\n    pointer-events: none;\n}\n\n.quote-container {\n    width: 90%;\n    max-width: 800px;\n    border-radius: 10px;\n    padding: 40px;\n}\n\n.quote-text {\n    font-family: \"Noto Sans Tamil\", Arial, sans-serif;\n    font-size: 32px;\n    line-height: 1.4;\n    margin-bottom: 20px;\n    color: var(--quote-color);\n    text-align: left;\n    /* Debug styles to ensure visibility */\n    min-height: 30px;\n}\n.quote-text > div {\n    white-space: nowrap;\n    overflow-wrap: normal;\n    word-break: keep-all;\n}\n\n.quote-explanation, .quote-mv {\n    font-size: 20px;\n    line-height: 1.5;\n    margin-bottom: 20px;\n    color: var(--quote-color);\n    text-align: left;\n}\n\n.quote-number {\n    font-size: 28px;\n    color: var(--metadata-color);\n    text-align: left;\n    margin-bottom: 15px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.refresh-button {\n    border: 1px solid var(--tree-color);\n    background: transparent;\n    color: var(--metadata-color);\n    border-radius: 999px;\n    padding: 6px 12px;\n    font-size: 12px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n\n.refresh-button:hover {\n    color: var(--text-color);\n    border-color: var(--text-color);\n}\n\n.quote-metadata {\n    font-size: 16px;\n    color: var(--metadata-color);\n    text-align: left;\n    margin-bottom: 15px;\n    /* Debug styles to ensure visibility */\n    min-height: 20px;\n}\n\n.metadata-placeholder {\n    font-style: italic;\n    opacity: 0.7;\n}\n\n.metadata-tree {\n    position: relative;\n    padding-left: 15px;\n    display: block;\n    color: var(--metadata-color);\n    text-decoration: none;\n    transition: color 0.3s ease;\n}\n\n.metadata-tree:visited {\n    color: var(--metadata-color);\n}\n\n.metadata-tree:hover,\n.metadata-tree:active {\n    color: var(--quote-color);\n}\n\n.metadata-tree::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 1px;\n    background-color: var(--tree-color);\n    transition: background-color 0.3s ease;\n}\n\n.metadata-tree .section {\n    margin-bottom: 5px;\n}\n\n.metadata-tree .chapter {\n    position: relative;\n    padding-left: 10px;\n}\n\n.metadata-tree .chapter::before {\n    content: '';\n    position: absolute;\n    left: -15px;\n    top: 50%;\n    width: 16px;\n    height: 1px;\n    background-color: var(--tree-color);\n    transition: background-color 0.3s ease;\n}\n\n.metadata-tree:hover::before,\n.metadata-tree:hover .chapter::before {\n    background-color: var(--quote-color);\n}\n\n.mode-toggle {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n}\n\n.mode-switch {\n    display: none;\n}\n\n.mode-switch-label {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    background-color: var(--bg-color);\n    border-radius: 50%;\n    transition: background-color 0.3s ease;\n}\n\n.sun-moon-icon {\n    width: 24px;\n    height: 24px;\n    transition: transform 0.3s ease;\n}\n\n.sun, .sun-ray {\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.moon {\n    opacity: 1;\n    transition: opacity 0.3s ease;\n}\n\n.mode-switch:checked + .mode-switch-label .sun,\n.mode-switch:checked + .mode-switch-label .sun-ray {\n    opacity: 1;\n}\n\n.mode-switch:checked + .mode-switch-label .moon {\n    opacity: 0;\n}\n\n.mode-switch:checked + .mode-switch-label .sun-moon-icon {\n    transform: rotate(180deg);\n}\n\nbody.no-transition .mode-switch-label,\nbody.no-transition .sun-moon-icon,\nbody.no-transition .sun,\nbody.no-transition .sun-ray,\nbody.no-transition .moon {\n    transition: none !important;\n}\n\na { color: inherit; \n  text-decoration: none;\n} \n\n.star-button {\n    border: 1px solid var(--tree-color);\n    background: transparent;\n    color: var(--metadata-color);\n    border-radius: 999px;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.star-button:hover {\n    color: var(--text-color);\n    border-color: var(--text-color);\n}\n\n.star-button.is-starred {\n    color: var(--text-color);\n    border-color: var(--text-color);\n}\n\n.star-icon {\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 1.6;\n    stroke-linejoin: round;\n}\n\n.star-button.is-starred .star-icon {\n    fill: currentColor;\n    stroke: currentColor;\n}\n\n.favourites-section {\n    margin-top: 20px;\n    text-align: left;\n    position: relative;\n}\n\n.favourites-toggle {\n    border: 1px solid var(--tree-color);\n    background: transparent;\n    color: var(--metadata-color);\n    border-radius: 6px;\n    padding: 8px 12px;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.favourites-toggle:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.favourites-toggle:hover:not(:disabled) {\n    color: var(--text-color);\n    border-color: var(--text-color);\n}\n\n.favourites-list {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(100% + 12px);\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    max-height: 320px;\n    overflow-y: auto;\n    padding-right: 6px;\n    padding: 10px;\n    border: 1px solid var(--tree-color);\n    border-radius: 8px;\n    background: var(--bg-color);\n    z-index: 10;\n    scrollbar-width: thin;\n    scrollbar-color: var(--tree-color) transparent;\n}\n\n.favourites-list::-webkit-scrollbar {\n    width: 8px;\n}\n\n.favourites-list::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.favourites-list::-webkit-scrollbar-thumb {\n    background-color: var(--tree-color);\n    border-radius: 999px;\n    border: 2px solid transparent;\n    background-clip: padding-box;\n}\n\n.favourites-list::-webkit-scrollbar-thumb:hover {\n    background-color: var(--metadata-color);\n}\n\n.favourites-item {\n    border: 1px solid var(--tree-color);\n    background: transparent;\n    color: var(--quote-color);\n    border-radius: 6px;\n    display: flex;\n    align-items: stretch;\n    gap: 8px;\n}\n\n.favourites-item:hover {\n    border-color: var(--quote-color);\n    color: var(--text-color);\n}\n\n.favourites-number {\n    color: var(--metadata-color);\n    font-size: 12px;\n    min-width: 26px;\n    text-align: center;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.favourites-line {\n    font-size: 14px;\n    display: block;\n    white-space: nowrap;\n    overflow-wrap: normal;\n    word-break: keep-all;\n}\n\n.favourites-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.favourites-select {\n    border: none;\n    background: transparent;\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    padding: 8px 10px;\n    flex: 1;\n}\n\n.favourites-remove {\n    border: none;\n    background: transparent;\n    color: var(--metadata-color);\n    cursor: pointer;\n    padding: 8px 10px;\n    font-size: 12px;\n}\n\n.favourites-remove:hover {\n    color: var(--text-color);\n}\n\n.favourites-empty {\n    color: var(--metadata-color);\n    font-size: 14px;\n}\n\n\n\n@media (max-width: 600px) {\n    .quote-container {\n        width: 95%;\n        padding: 30px;\n    }\n\n    .quote-text {\n        font-size: 20px;\n    }\n\n    .quote-explanation, .quote-mv {\n        font-size: 16px;\n    }\n\n    .quote-number {\n        font-size: 12px;\n        margin-bottom: 10px;\n    }\n\n    .quote-metadata {\n        font-size: 12px;\n        margin-bottom: 10px;\n    }\n}\n\n.mode-switch-label,\n.mode-switch-label::after {\n    transition: all 0.3s ease;\n}\n\nbody.no-transition .mode-switch-label,\nbody.no-transition .mode-switch-label::after {\n    transition: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
